var exports = {
  "o": "x804f0401--0ef38e--block",
  "M": "x804f0401--0ef38e--block-shown",
};

module.exports = exports;
